<template>
    <ui-report-panel title="Accidents" :filters="filters" :fetch="fetch" @filtersChanged="({ refresh }) => refresh()" v-slot="{ report }">
        <ui-table v-if="report && report.length > 0" :headers="['Status', 'Reference', 'Project', 'Date']" v-slot="{ cellClass }">
            <tr v-for="accident in parseReport(report, filters)" :key="`${accident.id}-${accident.closed_at ? 'closed' : 'opened'}`" class="hover:bg-blue-50 cursor-pointer" @click="goTo(accident._links.frontend.view)">
                <td :class="cellClass">
                    <span v-if="accident.closed_at" class="px-2.5 py-0.5 inline-flex text-xs font-medium items-center rounded-full bg-pink-100 text-pink-800">
                        Closed
                    </span>
                    <span v-else class="px-2.5 py-0.5 inline-flex text-xs font-medium items-center rounded-full bg-green-100 text-green-800">
                        Opened
                    </span>
                </td>
                <td :class="cellClass" class="font-medium text-gray-900" v-text="accident.id"></td>
                <td :class="cellClass">
                    <a href="#" class="truncate hover:text-gray-900">
                        {{ accident.package_name | truncate(50) }}
                    </a>
                </td>
                <td :class="cellClass">
                    {{ accident.closed_at ? accident.closed_at : accident.opened_at }}
                    ({{ accident.closed_at ? accident.closed_for : accident.opened_for }})
                </td>
            </tr>
        </ui-table>
        <div v-else class="px-4 py-16 text-center text-gray-400">
            There has been no activity in accidents within the provided filters...
        </div>
    </ui-report-panel>
</template>

<script>
import { Accident } from '@models'

export default {
    props: {
        filters: Object,
        parseReport: Function,
    },
    methods: {
        async fetch (filters) {
            return await Accident.allWithActivity(filters)
        },
        goTo (url) {
            window.location = url
        },
    },
}
</script>
